// @ts-nocheck
import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import useGetSetting from "@insite/client-framework/Common/Hooks/useGetSetting";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer";
// import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer"; // Hercules Custom Code
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import X from "@insite/mobius/Icons/X";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { useEffect, useState } from "react";
import { css } from "styled-components";

/* Hercules Custom Code - Start */
import translate from "@insite/client-framework/Translate";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import getColor from "@insite/mobius/utilities/getColor";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Hercules Custom Code - End */

export interface CookiePrivacyPolicyPopupStyles {
    drawer?: DrawerPresentationProps;
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    messageText?: TypographyPresentationProps;
    acceptGridItem?: GridItemProps;
    acceptButton?: ButtonPresentationProps;
    closeGridItem?: GridItemProps;
    closeButton?: ClickablePresentationProps /* Hercules Custom Code */;
}

export const cookiePrivacyPolicyPopupStyles: CookiePrivacyPolicyPopupStyles = {
    drawer: {
        position: "bottom",
        /* Hercules Custom Code - Start */
        size: 80,
        /* Hercules Custom Code - End */
        cssOverrides: {
            drawerTitle: css`
                display: none;
            `,
            drawerContent: css`
                /* Hercules Custom Code - Start */
                padding: ${pxToRem(15)} ${pxToRem(96)};
                ${breakpoint("sm", "down")} {
                    padding: ${pxToRem(15)} ${pxToRem(8)};
                }
                background-color: ${getColor("info")};
                font-weight: ${x => x.theme.design.typography.weight.bold};
                /* Hercules Custom Code - End */
                margin: 0 auto;
                width: 100%;
            `,
        },
        closeButtonProps: {
            css: css`
                display: none;
            `,
        },
        enableClickThrough: true,
    },
    container: {
        gap: 10,
        css: css`
            margin: 0 auto;
            /* Hercules Custom Code - Start */
            display: flex;
            align-items: center;
            > ${GridOffset} {
                flex-wrap: nowrap;
            }
            /* Hercules Custom Code - End */
        `,
    },
    /* Hercules Custom Code - Start */
    messageGridItem: {
        width: [12, 12, 7, 10, 10],
        css: css`
            align-items: center;
        `,
    },
    acceptGridItem: {
        width: [4, 3, 2, 1, 1],
        css: css`
            min-width: ${pxToRem(175)};
            justify-content: flex-end;
            align-items: center;
        `,
    },
    acceptButton: {
        variant: "inverted" as any,
    },
    closeGridItem: {
        width: [4, 3, 2, 1, 1],
        css: css`
            justify-content: flex-end;
            align-items: center;
        `,
    },
    closeButton: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.base};
            color: ${getColor("primary.contrast")};
        `,
    },
    messageText: {
        css: css`
            color: ${getColor("primary.contrast")};
        `,
    },
    /* Hercules Custom Code - End */
};

const styles = cookiePrivacyPolicyPopupStyles;

const CookiePrivacyPolicyPopup = () => {
    const location = useAppSelector(o => getLocation(o));
    const enableCookiePrivacyPolicyPopup = useGetSetting(o => o.websiteSettings.enableCookiePrivacyPolicyPopup);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (enableCookiePrivacyPolicyPopup && !getCookie("acceptCookies")) {
            setIsOpen(true);
        }
    }, [location.pathname]);

    const acceptHandler = () => {
        setIsOpen(false);
        setCookie("acceptCookies", "true", { expires: 365 });
    };

    const closeHandler = () => {
        setIsOpen(false);
    };

    return (
        <Drawer isOpen={isOpen} {...styles.drawer} data-test-selector="drawer_CookiePolicy">
            <GridContainer {...styles.container}>
                <GridItem {...styles.messageGridItem}>
                    <Typography {...styles.messageText} data-test-selector="cookiePolicy_PrivacyPolicy">
                        {siteMessage("Core_CookiePrivacyPolicy")}
                    </Typography>
                </GridItem>
                {/* Hercules Custom Code - Start */}
                <GridItem {...styles.closeGridItem}>
                    <Clickable {...styles.closeButton} onClick={closeHandler}>
                        {translate("Close")}
                    </Clickable>
                </GridItem>
                {/* Hercules Custom Code - End */}
                <GridItem {...styles.acceptGridItem}>
                    <Button
                        {...styles.acceptButton}
                        onClick={acceptHandler}
                        data-test-selector="cookiePolicy_AcceptCookies"
                    >
                        {siteMessage("Core_CookiePrivacyPolicyAccept")}
                    </Button>
                </GridItem>
                {/* Hercules Moved Code - closeGridItem */}
            </GridContainer>
        </Drawer>
    );
};

export default CookiePrivacyPolicyPopup;
